var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { Component } from "react";
import { connect } from "react-redux";
import withBranding from "@irati/brand/withBranding";
import AuthActions from "@irati/auth/store/actions/AuthActions";
import authentication from "@irati/auth";
import Button from "@irati/ui/src/Button";
import { injectIntl, FormattedMessage } from "@irati/utils/lang";
import brandingService from "@irati/brand/services/branding";
import defaultAuth from "@irati/auth/helpers/defaultAuth";
import { PlaceholderContainer } from "@irati/ui/src/Placeholder";
import { H2 } from "@irati/ui/src/Headings";
import { Para } from "@irati/ui/src/Labels";
import Flex from "@irati/ui/src/Flex";
import Validation from "@irati/utils/validation";
import ValidationButton from "@irati/ui/src/FormItem/ValidationButton";
import Header from "./Header";
import EmailContent from "./EmailContent";
import { MarginButton, TwoColorBackground, EmailPreviewContainer, PreviewTextContainer, StyledTextArea } from "../styled";
var WELCOME_EMAIL_KEY = "admin.components.welcomeEmail.default";
var Preview = /** @class */ (function (_super) {
    __extends(Preview, _super);
    function Preview() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            welcomeEmailDraft: "",
            editing: true
        };
        _this.updateWelcomeEmail = function () {
            var _a = _this.props, setIsStepCompletable = _a.setIsStepCompletable, updateAuth = _a.updateAuth;
            var tenant = authentication.userTenant();
            var data = {
                businessId: tenant.uuid,
                teamId: tenant.rootTeamId,
                welcomeEmail: _this.state.welcomeEmailDraft
            };
            var saving = brandingService.update(data).then(function () { return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, Promise.all([setIsStepCompletable(true), updateAuth()])];
                        case 1:
                            _a.sent();
                            this.setState({ editing: false });
                            return [2 /*return*/];
                    }
                });
            }); });
            _this.setState({ saving: saving });
        };
        _this.getDefaultEmailString = function () { return _this.props.formatMessage({ id: WELCOME_EMAIL_KEY }); };
        _this.handleChange = function (value) {
            _this.setState({ welcomeEmailDraft: value });
        };
        _this.handleReset = function () { return _this.setState({ welcomeEmailDraft: _this.getDefaultEmailString() }); };
        _this.emailValidationSchema = Validation.string()
            .required("platform.defaultValidation.required")
            .max(650, _this.props.formatMessage({ id: "platform.defaultValidation.maxLength" }, { count: 650 }))
            .test("notMatchDefault", _this.props.formatMessage({ id: "setup_tenant.steps.welcomeEmail.preview.emailValidationMessage" }), function (value) { return value !== _this.getDefaultEmailString(); });
        return _this;
    }
    Preview.prototype.componentDidMount = function () {
        var _this = this;
        return brandingService.get({ fetchPolicy: "network-only" }).then(function (branding) {
            var welcomeEmailDraft = branding.welcomeEmail || _this.getDefaultEmailString();
            var isDefaultEmail = welcomeEmailDraft === _this.getDefaultEmailString();
            _this.setState({ welcomeEmailDraft: welcomeEmailDraft, editing: isDefaultEmail });
        });
    };
    Preview.prototype.render = function () {
        var _this = this;
        var _a = this.props, useDefault = _a.useDefault, branding = _a.branding;
        var _b = this.state, welcomeEmailDraft = _b.welcomeEmailDraft, editing = _b.editing, saving = _b.saving;
        var businessLogoUrl = branding.businessLogoUrl, primaryColour = branding.primaryColour;
        var defaultImageLink = defaultAuth.userTenant.settings.imageLink;
        var showCustomLogo = defaultImageLink !== businessLogoUrl;
        return (React.createElement(React.Fragment, null,
            React.createElement(Flex, { alignItems: "center", justifyContent: "space-between", margin: "10px 0" },
                React.createElement(Para, null,
                    React.createElement(FormattedMessage, { id: "setup_tenant.steps.welcomeEmail.preview.introCaption" })),
                !editing && (React.createElement(Button, { primary: true, onClick: function () { return _this.setState({ editing: true }); } },
                    React.createElement(FormattedMessage, { id: "setup_tenant.steps.welcomeEmail.preview.editMessageButton" })))),
            React.createElement(PlaceholderContainer, { padding: "30px", margin: "15px 0 0 0" },
                React.createElement(Header, { showCustomLogo: showCustomLogo, perkboxImageLink: defaultImageLink, customLogoLink: businessLogoUrl }),
                React.createElement(TwoColorBackground, { color1: primaryColour },
                    React.createElement(EmailPreviewContainer, null,
                        React.createElement(H2, { tiny: true },
                            React.createElement(FormattedMessage, { id: "setup_tenant.steps.welcomeEmail.preview.email.greeting" })),
                        useDefault && React.createElement(EmailContent, null),
                        !useDefault && !editing && React.createElement(EmailContent, { welcomeEmail: welcomeEmailDraft }),
                        !useDefault && editing && (React.createElement(Flex, { width: "100%", direction: "column", alignItems: "center", justifyContent: "space-between" },
                            React.createElement(PreviewTextContainer, { border: true },
                                React.createElement(StyledTextArea, { name: "welcomeEmail", label: "Your message", hideLabel: true, value: welcomeEmailDraft, rows: 8, onChange: this.handleChange, validation: this.emailValidationSchema }),
                                React.createElement(Flex, null,
                                    React.createElement(MarginButton, { onClick: this.handleReset },
                                        React.createElement(FormattedMessage, { id: "setup_tenant.steps.welcomeEmail.preview.defaultMessageButton" })),
                                    React.createElement(ValidationButton, { primary: true, onClick: this.updateWelcomeEmail, load: saving },
                                        React.createElement(FormattedMessage, { id: "setup_tenant.steps.welcomeEmail.preview.saveMessageButton" })))))))))));
    };
    return Preview;
}(Component));
var mapDispatchToProps = function (dispatch) {
    return {
        updateAuth: function () { return dispatch(AuthActions.updateTenant()); }
    };
};
export default connect(null, mapDispatchToProps)(injectIntl(withBranding(Preview)));
